import { motion } from 'framer-motion';
import React from 'react';

export const FlatworldIcon = ({ className = '' }) => {
  return (
    <motion.div
      className="relative group"
      whileHover={{ scale: 1.1 }}
    >
      {/* 发光效果 - 紫色光晕 */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-400/30 to-fuchsia-400/30 blur-md transition-opacity duration-300 opacity-0 group-hover:opacity-100" />
      
      {/* Flatworld 图标 */}
      <div className={`relative aspect-square ${className}`}>
        {/* 主体形状 - 正方形 */}
        <div className="absolute inset-0 bg-gradient-to-br from-violet-500/90 via-indigo-500/90 to-purple-500/90 backdrop-blur-sm border border-purple-300/60 shadow-lg rounded-lg" />
        
        {/* 内部装饰 - 优雅的内框 */}
        <div className="absolute inset-2 border border-white/40 rounded-md" />
        <div className="absolute inset-3 border border-white/30 rounded-sm" />
        
        {/* 中心点 - 明亮的核心 */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-1.5 h-1.5 bg-gradient-to-br from-amber-300 to-yellow-200 transform rotate-45 shadow-sm" />
        </div>
        
        {/* 四个角的装饰点 - 精致的点缀 */}
        <div className="absolute inset-0">
          <div className="absolute top-1 left-1 w-1 h-1 bg-white/70 rounded-full" />
          <div className="absolute top-1 right-1 w-1 h-1 bg-white/70 rounded-full" />
          <div className="absolute bottom-1 left-1 w-1 h-1 bg-white/70 rounded-full" />
          <div className="absolute bottom-1 right-1 w-1 h-1 bg-white/70 rounded-full" />
        </div>
      </div>
    </motion.div>
  );
};

export default FlatworldIcon;
